"use client";

import { useCopyToClipboard } from "@pharaday/utils";
import { useState } from "react";

import { Button } from "../button";
import { CheckIcon, CopyIcon, EyeIcon, EyeOffIcon } from "../icons";
import { BasicTooltip } from "../tooltip";
import Input, { type TextFieldInputProps } from "./Input";

export type TextFieldPasswordProps = Omit<TextFieldInputProps, "type" | "suffixIcon"> & {
  showCopyButton?: boolean;
};

const Password = ({ ref: forwardedRef, showCopyButton = false, ...props }: TextFieldPasswordProps) => {
  const [show, setShow] = useState(false);
  const [copied, setCopied] = useState(false);
  const [_, copy] = useCopyToClipboard();

  const Icon = show ? EyeOffIcon : EyeIcon;
  const toggleShow = () => setShow(prev => !prev);
  const type = show ? "text" : "password";

  const handleCopy = () => {
    copy(props.value ?? "");
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  return (
    <>
      <style>
        {`
          input::-ms-reveal,
          input::-ms-clear {
            display: none;
          }
          `}
      </style>
      <Input
        {...props}
        type={type}
        ref={forwardedRef}
        suffix={
          <div className="relative h-4">
            <div className="absolute top-1/2 -right-2.5 flex -translate-y-1/2">
              <Button variant="ghost" icon size="xs" color="secondary" type="button" onClick={toggleShow}>
                <Icon className="size-5 text-neutral-30" />
              </Button>
              {showCopyButton &&
                (!copied ? (
                  <Button variant="ghost" icon size="xs" color="secondary" type="button" onClick={handleCopy}>
                    <CopyIcon className="size-5 text-neutral-30" />
                  </Button>
                ) : (
                  <BasicTooltip asChild content="Copied" side="top" sideOffset={-8}>
                    <Button className="bg-transparent!" variant="ghost" icon size="xs" color="secondary" type="button">
                      <CheckIcon className="size-5 text-success-50" />
                    </Button>
                  </BasicTooltip>
                ))}
            </div>
          </div>
        }
      />
    </>
  );
};

Password.displayName = "Password";

export default Password;
